import React from 'react';
import styled from 'styled-components';
import { Image } from '../Image/Image';
const RandomImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "PlaceholderImage__RandomImage",
  componentId: "sc-1yneblr-0"
})(["height:", "px;width:", "px;"], props => props.height, props => props.width);
const determineSRC = (blur, chooseSrc, height, width) => {
  const imageURLs = [`http://placeimg.com/${width}/${height}/any`, `http://placekitten.com/${width}/${height}`, `https://picsum.photos/${width}/${height}`, `https://source.unsplash.com/${width}x${height}`, `https://www.fillmurray.com/${width}/${height}`];
  if (blur || chooseSrc) {
    return blur ? `https://picsum.photos/${width}/${height}?blur` : imageURLs[chooseSrc];
  }
  const randomNum = Math.floor(Math.random() * imageURLs.length);
  return imageURLs[randomNum];
};
/**
 * @public
 */
export function PlaceholderImage({
  alt,
  ariaHidden = true,
  blur = false,
  chooseSrc,
  className,
  height = '500',
  width = '500'
}) {
  return React.createElement(RandomImage, {
    alt: alt || 'Random image used for placeholder content',
    "aria-hidden": ariaHidden,
    blur: blur,
    className: className,
    height: height,
    src: determineSRC(blur, chooseSrc, height, width),
    width: width
  });
}
PlaceholderImage.displayName = 'PlaceholderImage';